export enum EReportType {
  CHECKLIST_STAT = 'checklistStat',
  T4_MOBILE_USAGE = 't4MobileUsage',
}
